/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue';

Bugsnag.start({
    apiKey: process.env.MIX_BUGSNAG_API_KEY,
    releaseStage: process.env.MIX_BUGSNAG_APP_ENV
});

window.calendarLicenseKey = process.env.MIX_FULL_CALENDAR_KEY;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import * as VueGoogleMaps from "vue2-google-maps";
import {gmapApi} from "vue2-google-maps";
import MappedStores from "./components/MappedStores.vue";
import GoogleMap from "./components/GoogleMap.vue";
import AvailabilityCalendar from "./components/AvailabilityCalendar.vue";

// Specific Vue Components
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead);

Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.MIX_GOOGLE_API_KEY,
        libraries: "places" // necessary for places input
    }
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',

    components: {
        MappedStores,
        GoogleMap,
        AvailabilityCalendar
    },

    data: function () {
        return {
            mapStoreData: {},
            user: this.getAuthUser()
        }
    },

    mounted: function () {
        //
    },

    computed: {
        google: gmapApi
    },

    methods: {
        updateStoreData(variable) {
            this.mapStoreData = variable;
        },
        getAuthUser() {
            if (typeof window.authUser !== "undefined") {
                return JSON.parse(window.authUser);
            } else {
                return null;
            }
        },
        isLoggedIn() {
            return this.authUser !== null;
        }
    }
});

window.showError = function (text) {
    bootbox.alert({
        title: 'Error!',
        message: '' + text
    });
};

// For Datatables errors
window.onerror = function (errorMsg, url, lineNumber, column, errorObj) {
    if (typeof errorObj !== "undefined") {
        if (errorObj.namespace === "dt") return false;
        else Bugsnag.notify(errorObj);
    }
};

if (typeof window.authUser !== "undefined") {
    const user = JSON.parse(window.authUser);

    Bugsnag.setUser(user.id, user.email, user.name);
}

(function ($) {
    "use strict"; // Start of use strict

    //

})(jQuery); // End of use strict
